<template>
  <div
    id="postLogin"
    class="modal fade"
    data-bs-backdrop="static"
    style="zoom: 80%"
  >
    <ModalDialog size="lg">
      <ModalContent style="border: none">
        <div class="mb-4">
          <button
            type="button"
            class="btn-close custom-btn-close"
            aria-label="Close"
            style="position: absolute; right: 40px; top: 30px"
            v-if="postLoginData?.enabledClose === true"
            @click="handleClose"
          >
            <img
              src="@/assets/svg/white-outline-close.svg"
              alt="Close"
              width="30"
              height="30"
              style="max-width: unset"
            />
          </button>
          <img
            :src="postLoginData?.imageUrl"
            style="
              width: 100%;
              border-radius: 10px 10px 0 0;
              height: auto;
              max-height: 500px;
            "
          />
        </div>
        <h2 v-if="postLoginData?.headline" class="pb-4 px-5 text-center">
          {{ postLoginData?.headline }}
        </h2>
        <div style="padding: 0 2rem">
          <div class="card subtle-shadow">
            <div class="card-body">
              <p
                v-if="postLoginData?.description"
                class="px-4 mt-1 mb-3"
                style="color: rgb(81, 96, 105); overflow-wrap: break-word"
              >
                {{ postLoginData?.description }}
                <a
                  v-if="
                    postLoginData?.descriptionLinkUrl &&
                    postLoginData?.descriptionLinkText
                  "
                  :href="formatUrl(postLoginData?.descriptionLinkUrl)"
                  target="_blank"
                  >{{ postLoginData?.descriptionLinkText }}</a
                >
              </p>
              <ul class="px-5">
                <template v-for="(item, _index) in content" :key="_index">
                  <div
                    class="p-0 position-relative item-container"
                    v-if="
                      item.enabled === true && item.title && item.description
                    "
                  >
                    <li style="color: rgb(81, 96, 105)">
                      <h4 class="mb-0">
                        {{ item.title }}
                      </h4>
                      <p style="line-height: 1.5rem">
                        {{ item.description }}
                        <a
                          :href="formatUrl(item.hyperlinkUrl)"
                          target="_blank"
                          v-if="item.hyperlinkText && item.hyperlinkUrl"
                          >{{ item.hyperlinkText }}</a
                        >
                      </p>
                    </li>
                  </div>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="mt-5 px-5 mb-5 d-flex justify-content-end">
          <Button
            class="btn btn-light"
            style="
              background-color: white;
              border-color: gray;
              font-weight: 500;
            "
            @click="
              handleSecondaryBtnClicked(postLoginData?.secondaryButtonUrl)
            "
          >
            {{ postLoginData?.secondaryButtonName }}
          </Button>
          <Button
            class="btn btn-primary ms-2"
            @click="handlePrimaryBtnClicked(postLoginData?.mainButtonUrl)"
          >
            {{ postLoginData?.mainButtonName }}
          </Button>
        </div>
      </ModalContent>
    </ModalDialog>
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import ModalDialog from "@/components/uielements/modal/ModalDialog.vue";
import ModalContent from "@/components/uielements/modal/ModalContent.vue";
import Button from "@/components/uielements/button/Button.vue";
import { usePostLoginAnnouncement } from "@/stores/postLoginAnnouncement.js";

const postLoginStore = usePostLoginAnnouncement();

const emit = defineEmits(["second-cta", "main-cta", "seen"]);
const postLoginData = computed(() => postLoginStore.selectedPostLogin);

const formatUrl = (url) => {
  if (!/^https?:\/\//i.test(url)) {
    return "https://" + url;
  }
  return url;
};

const handlePrimaryBtnClicked = (url) => {
  postLoginStore.postLoginModal.hide();
  emit("main-cta", postLoginData.value.id);
  window.location.href = formatUrl(url);
};

const handleSecondaryBtnClicked = (url) => {
  postLoginStore.postLoginModal.hide();
  if (url === "") {
    emit("second-cta", postLoginData.value.id);
  } else {
    emit("second-cta", postLoginData.value.id);
    window.location.href = formatUrl(url);
  }
};

const handleClose = () => {
  postLoginStore.sendModalToBell("postLogin", () => {
    postLoginStore.postLoginModal.hide();
  });
};

const content = computed(() => {
  return (
    postLoginData.value?.content?.map((data) => {
      return { ...data };
    }) || []
  );
});

watch(
  () => postLoginStore.postLoginModal,
  (modal) => {
    if (modal) {
      const modalElement = document.getElementById("postLogin");

      modalElement.addEventListener("shown.bs.modal", () => {
        if (postLoginData.value && postLoginData.value.seen === false) {
          emit("seen", postLoginData.value.id);
        }
      });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.item-container {
  position: relative;
  margin-bottom: 1.5rem;
}
.btn-close.custom-btn-close {
  background: none;
}
</style>
